import { motion } from "framer-motion";
import { ClipboardCheck, Eye, Wrench, FileText, ArrowDown } from "lucide-react";

const steps = [
  {
    icon: ClipboardCheck,
    title: "Accueil",
    duration: "5 min",
    color: "bg-autosur-blue",
    items: [
      "Vérification de la carte grise",
      "Prise en charge du véhicule",
      "Explication du processus",
    ],
  },
  {
    icon: Eye,
    title: "Inspection visuelle",
    duration: "10 min",
    color: "bg-autosur-navy",
    items: [
      "Éclairage (phares, feux, clignotants)",
      "Pneus (usure, pression, craquelures)",
      "Équipements (essuie-glaces, ceintures, rétroviseurs)",
      "Structure (corrosion, pare-brise, carrosserie)",
    ],
  },
  {
    icon: Wrench,
    title: "Contrôle technique",
    duration: "20-30 min",
    color: "bg-autosur-red",
    items: [
      "Banc de freinage",
      "Test d'émissions polluantes",
      "Test d'éclairage et réglage phares",
      "Mesure du bruit d'échappement",
      "Vérification de la géométrie",
    ],
  },
  {
    icon: FileText,
    title: "Résultats",
    duration: "5 min",
    color: "bg-green-600",
    items: [
      "Résultat favorable (A) : Procès-verbal immédiat",
      "Défaillances majeures (S) : Contre-visite 2 mois",
      "Défaillances critiques (R) : Immobilisation",
      "Explication détaillée des résultats",
    ],
  },
];

export const ProcessInfographic = () => {
  return (
    <section className="py-20 bg-background">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <span className="text-autosur-red font-heading font-semibold tracking-widest text-sm mb-4 block">
            ÉTAPE PAR ÉTAPE
          </span>
          <h2 className="font-heading text-3xl font-bold text-autosur-navy mb-4">
            Comment se déroule votre contrôle technique ?
          </h2>
          <p className="font-body text-muted-foreground max-w-2xl mx-auto">
            De l'accueil au résultat, votre contrôle technique dure 30 à 45 minutes. 
            Voici le détail de chaque étape.
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto space-y-0">
          {steps.map((step, index) => (
            <div key={step.title}>
              <motion.div
                initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
                className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100"
              >
                <div className="flex items-start gap-4">
                  <div className={`w-14 h-14 ${step.color} rounded-xl flex items-center justify-center flex-shrink-0`}>
                    <step.icon className="w-7 h-7 text-white" />
                  </div>
                  <div className="flex-1">
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-heading font-bold text-autosur-navy">
                        Étape {index + 1} : {step.title}
                      </h3>
                      <span className="font-body text-xs text-white bg-autosur-navy/80 px-3 py-1 rounded-full">
                        {step.duration}
                      </span>
                    </div>
                    <ul className="space-y-1">
                      {step.items.map((item) => (
                        <li key={item} className="font-body text-muted-foreground text-sm flex items-start gap-2">
                          <span className="text-autosur-blue mt-1 font-bold">✓</span>
                          {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </motion.div>
              {index < steps.length - 1 && (
                <div className="flex justify-center py-2">
                  <ArrowDown className="w-5 h-5 text-autosur-blue/40" />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Summary */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-3xl mx-auto mt-8 bg-autosur-navy rounded-2xl p-6 text-white text-center"
        >
          <div className="grid grid-cols-3 gap-4">
            <div>
              <p className="font-heading text-2xl font-bold">30-45</p>
              <p className="font-body text-white/70 text-sm">minutes</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-bold">Immédiat</p>
              <p className="font-body text-white/70 text-sm">résultat</p>
            </div>
            <div>
              <p className="font-heading text-2xl font-bold">73€</p>
              <p className="font-body text-white/70 text-sm">en ligne</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
